<template>
  <div class="bg-grey-v2">
    <newdashboardQuicklinks @on-click="checkGraceTxns" />
    <newdashboardSlider :content="promotions"></newdashboardSlider>
    <div class="container">
      <div class="row mb-10">
        <div class="section-header-card">
          <div class="section-header-card__text">ePayLater Merchants</div>
          <div class="section-header-card__stat">
            <router-link :to="{name: 'MerchantsV2'}">More</router-link>
          </div>
        </div>
        <div class="categories">
          <ul class="list-unstyled">
            <ul class="list-inline list-unstyled" v-if="activeCategory">
              <li v-for="(merchant, index) in activeCategory.marketplaces" :key="index">
                <figure class="text-center">
                  <div>
                    <img
                      :src="merchant.marketplaceLogoUrl"
                      :alt="merchant.marketplaceName"
                      width="34px"
                    />
                  </div>
                  <figcaption>{{ merchant.marketplaceName }}</figcaption>
                </figure>
              </li>
            </ul>
          </ul>
        </div>
      </div>
      <div
        class="row mb-10"
        v-if="recentTransactions.response&&recentTransactions.response.length>0"
      >
        <div class="section-header-card">
          <img
            src="/static/images/svgs/history-clock-button.svg"
            alt="Operator"
            class="section-header-card__image"
          />
          <div class="section-header-card__text">Recent Transactions</div>
          <div class="section-header-card__stat">
            <router-link :to="{name: 'Transaction'}">More</router-link>
          </div>
        </div>
        <EplNewTransaction cardHeader="false" txnCount="3" />
      </div>
      <router-link
        :to="{name: 'InviteAndUpgrade'}"
        v-if="user.features && user.features.referral.enabled"
      >
        <img
          src="/static/images/invite friends.png"
          class="invite-friends__image"
          alt="Invite Friends"
        />
      </router-link>
    </div>
    <MobileNav :activeLink="'home'" class="visible-xs mt-50"></MobileNav>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import MobileNav from "../components/EplNewMobileNav/index";
import newdashboardQuicklinks from "../components/QuickLinksMobile/index";
import newdashboardSlider from "../components/NewDashboardSlider/index";
import EplNewTransaction from "../components/EplNewTransaction";
export default {
  components: {
    // TransactionList,
    newdashboardQuicklinks,
    newdashboardSlider,
    MobileNav,
    EplNewTransaction
  },
  computed: {
    ...mapGetters(["categories", "recentTransactions", "user"])
  },
  data() {
    return {
      recent_txn_params: {
        start: 0,
        count: 3
      },
      activeCategory: undefined,
      promotions: [{ logoUrl: "/static/images/Banner.jpg" }]
    };
  },
  mounted() {
    this.loadRecentTransactions(false);
    this.$store.dispatch("merchants").then(response => {
      this.activeCategory = this.categories[0];
    });
  },
  methods: {
    loadRecentTransactions(append) {
      var query = this.recent_txn_params;

      if (append) {
        query = {
          params: this.recent_txn_params,
          append
        };
      }
      this.$store.dispatch("recentTransactions", query).then(resp => {
        this.recentTxnsLoaded = true;
      });
    },
    checkGraceTxns(link) {
      if (this.user.kycRequired || this.user.emandateRequired) {
        this.$emit("showGraceTxnsModal", link);
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.clearfix {
  clear: both;
}

.invite-section {
  padding: 30px 0;
  background: #64b664;
  min-height: 180px;
  border-radius: 9px;
  margin-bottom: 10px;
}

ul {
  margin: 0;
  display: flex;
  display: -webkit-flex;
  background: #ffffff;
  overflow: auto;
  li {
    flex: 1;
    div {
      height: 70px;
      padding: 20px;
      img {
        max-width: 36px;
        margin-bottom: 05px;
      }
    }
    figcaption {
      font-family: Overpass;
      font-size: 12px;
      font-weight: normal;
      font-style: normal;
      font-stretch: normal;
      line-height: normal;
      letter-spacing: normal;
      text-align: center;
      color: #718099;
      margin-bottom: 10px;
    }
  }
}

.title {
  font-size: 22px;
  color: #ffffff;
}
.p-0 {
  padding: 0px;
}
.pr-22 {
  padding-right: 22px;
}
.subtitle {
  font-size: 15px;
  line-height: 20px;
  color: #ffffff;
}
.btn {
  padding: 9px 27px;
  border-radius: 20px;
  margin-right: 10px;
  background: #ffffff;
}
.btn.active.focus,
.btn.active:focus,
.btn.focus,
.btn:active.focus,
.btn:active:focus,
.btn:focus {
  outline: none;
  outline-offset: -2px;
}
.invite-friends__image {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/EplNewDashboardFooterMobile.vue